import { FeedItem, FeedItemDto, FeedItemEntity } from '../..';
import { FirestoreEntity, Mapper, TimestampDtoToTimestampMapper } from '../../../@harmony';
import { Timestamp } from 'firebase/firestore';

export class FeedItemToFeedItemEntityMapper
  implements Mapper<FeedItem, FirestoreEntity<FeedItemEntity>>
{
  public map(from: FeedItem): FirestoreEntity<FeedItemEntity> {
    return new FirestoreEntity(from.id, {
      _version: 0,
      caption: from.caption,
      createdAt: Timestamp.fromDate(from.createdAt),
      driveId: from.driveId,
      fileId: from.fileId,
      fileName: from.fileName,
      folderId: from.folderId,
      folderName: from.folderName,
      albumId: from.albumId,
      metadata: from.metadata,
      mime: from.mime,
      provider: from.provider,
      tags: [...from.tags],
      teamId: from.teamId,
      uploadedAt: from.uploadedAt ? Timestamp.fromDate(from.uploadedAt) : undefined,
      uploadedBy: from.uploadedBy,
      publicUrl: from.publicUrl,
      publicLargeUrl: from.publicLargeUrl,
      publicThumbUrl: from.publicThumbUrl,
      galleryRefs: from.galleryRefs.length ? [...from.galleryRefs] : undefined,
    });
  }
}

export class FeedItemDtoToFeedItemEntityMapper
  implements Mapper<FeedItemDto, FirestoreEntity<FeedItemEntity>>
{
  private readonly timestampMapper = new TimestampDtoToTimestampMapper();

  public map(from: FeedItemDto): FirestoreEntity<FeedItemEntity> {
    return {
      id: from.id,
      data: {
        ...from.data,
        createdAt: this.timestampMapper.map(from.data.createdAt),
        uploadedAt: from.data.uploadedAt
          ? this.timestampMapper.map(from.data.uploadedAt)
          : undefined,
      },
    };
  }
}

export class FeedItemEntityToFeedItemMapper
  implements Mapper<FirestoreEntity<FeedItemEntity>, FeedItem>
{
  public map(from: FirestoreEntity<FeedItemEntity>): FeedItem {
    return new FeedItem(
      from.id,
      from.data.caption,
      from.data.createdAt.toDate(),
      from.data.driveId,
      from.data.fileId,
      from.data.fileName,
      from.data.folderId,
      from.data.folderName,
      from.data.albumId,
      from.data.metadata,
      from.data.mime,
      from.data.provider,
      from.data.tags ?? [],
      from.data.teamId,
      from.data.uploadedAt ? from.data.uploadedAt.toDate() : undefined,
      from.data.uploadedBy,
      from.data.publicUrl,
      from.data.publicLargeUrl,
      from.data.publicThumbUrl,
      from.data.galleryRefs ?? [],
    );
  }
}
